import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import Typewriter from "typewriter-effect/dist/core";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

let consoleTitle = document.querySelector("#console-title");
let compiledText = document.querySelector("#compiled-text");
let aboutInfo = document.querySelector("#about-info");
let projectsWrapper = document.querySelector("#projects");
let links = document.querySelector("#links");

let runCommand = new Typewriter("#run-command", {
  cursor: "_",
});

runCommand.typeString("npm run portfolio").start();
setTimeout(() => {
  consoleTitle.innerHTML = "npm run portfolio";

  compiledText.classList.remove("invisible");
  setTimeout(() => {
    aboutInfo.classList.remove("invisible");
    projectsWrapper.classList.remove("invisible");
    links.classList.remove("invisible");
  }, 500);
}, 3000);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
